<div class="text-container {{side}}">
    <div class="image-side">
        <img [src]="imageUrl" alt="Image" class="image" /> 
    </div>
    <div class="text-side">
        <div class="text-content">
            <ng-content></ng-content>
        </div>
    </div>
</div>